const relativeTime = {
  now: "עכשיו",
  inMinutes: "בעוד {n} דק׳",
  inHours: "בעוד {n} שע׳",
} as const;
export default relativeTime;
